import React, {Dispatch, forwardRef, RefObject, useImperativeHandle, useRef} from 'react';
import parseFileName from 'common/src/utils/fileUtils/parseFileName';
import {emit} from 'common/src/modules/toasts/toasts.utils';
import {ACCEPTED_TYPES} from '../DAMCreate/DAMCreate';

interface DAMUploadInputProps {
  onUpload: Dispatch<File[]>;
  acceptedTypes?: Record<string, string>;
}

export interface DAMUploadInputRef {
  uploadFiles(): void;
  uploadFolder(): void;
}

function DAMUploadInput(
  {onUpload, acceptedTypes = ACCEPTED_TYPES}: DAMUploadInputProps,
  ref: RefObject<DAMUploadInputRef>,
) {
  const inputRef = useRef<HTMLInputElement>();
  useImperativeHandle(ref, () => ({
    uploadFiles() {
      inputRef.current.removeAttribute('webkitdirectory');
      inputRef.current.removeAttribute('mozdirectory');
      inputRef.current.removeAttribute('directory');
      inputRef.current.setAttribute('multiple', 'multiple');
      inputRef.current.click();
    },
    uploadFolder() {
      inputRef.current.setAttribute('webkitdirectory', 'webkitdirectory');
      inputRef.current.setAttribute('mozdirectory', 'mozdirectory');
      inputRef.current.setAttribute('directory', 'directory');
      inputRef.current.removeAttribute('multiple');
      inputRef.current.click();
    },
  }));

  return (
    <input
      ref={inputRef}
      type="file"
      style={{display: 'none'}}
      accept={Object.keys(acceptedTypes)
        .map((x) => '.' + x)
        .join(',')}
      onChange={(e) => {
        const files = [...e.target.files];
        const filteredFiles = files.filter((file) =>
          Object.keys(acceptedTypes).includes(parseFileName(file.name).fileExtension.toLowerCase()),
        );

        if (!filteredFiles.length && files.length) {
          e.target.value = '';
          emit.error({
            message: `Unsupported file type ${parseFileName(files[0].name).fileExtension}.`,
          });

          return;
        }

        onUpload(filteredFiles);
        e.target.value = '';
      }}
    />
  );
}

export default forwardRef(DAMUploadInput);
